var _rect, _g, _path, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarraArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 277,
    viewBox: "0 0 384 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_101",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -103,
    y: 0,
    width: 487,
    height: 276
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -103,
    width: 487,
    height: 276,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.3076 317.166L178.56 194.156L96.5659 75.7831H229.5L310.95 194.156L223.235 316.893L84.3076 317.166V317.166Z",
    fill: "#33CCC4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.709 136.349L77.0084 1H228.922L322 136.349L221.762 276.688L63 277L170.709 136.349Z",
    fill: "#FF3434"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_101",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 1,
    width: 259,
    height: 276
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.709 136.349L77.0084 1H228.922L322 136.349L221.762 276.688L63 277L170.709 136.349Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_101)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarraArrows);
export default __webpack_public_path__ + "static/media/marra_arrows.ecda6c3bc15687e0bdff34b6cbc06419.svg";
export { ForwardRef as ReactComponent };